"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addMeToYourFriendsDiv = void 0;
exports.checkIfThingExists = checkIfThingExists;
exports.createAddMeToYourFriendsButton = void 0;
exports.saveNewThing = saveNewThing;
var _litHtml = require("lit-html");
var _solidLogic = require("solid-logic");
var _rdflib = require("rdflib");
var _solidUi = require("solid-ui");
var _buttonsHelper = require("./buttonsHelper");
var _texts = require("./texts");
require("./styles/ProfileCard.css");
let buttonContainer = document.createElement('section');
const addMeToYourFriendsDiv = (subject, context, viewerMode) => {
  buttonContainer = context.dom.createElement('section');
  buttonContainer.setAttribute('class', 'buttonSubSection text-truncate text-center section-centered');
  buttonContainer.setAttribute('aria-labelledby', 'add-me-to-your-friends-button-section');
  buttonContainer.setAttribute('data-testid', 'button');

  // Add a visually hidden heading for accessibility
  const heading = context.dom.createElement('h3');
  heading.setAttribute('id', 'add-me-to-your-friends-button-section');
  heading.setAttribute('class', 'sr-only');
  heading.textContent = 'Add me to your friends actions';
  buttonContainer.appendChild(heading);
  const button = createAddMeToYourFriendsButton(subject, context);
  button.classList.add('profile__action-button', 'profile__btn-friends', 'flex-center');
  buttonContainer.appendChild(button);
  return (0, _litHtml.html)`${buttonContainer}`;
};
exports.addMeToYourFriendsDiv = addMeToYourFriendsDiv;
const createAddMeToYourFriendsButton = (subject, context) => {
  let label = _texts.addMeToYourFriendsButtonText;
  const button = context.dom.createElement('button');
  button.type = 'button';
  button.textContent = label;
  button.addEventListener('click', setButtonHandler);
  function setButtonHandler(event) {
    event.preventDefault();
    saveNewThing(subject, context, _solidUi.ns.foaf('knows')).then(() => {
      (0, _buttonsHelper.clearPreviousMessage)(buttonContainer);
      (0, _buttonsHelper.mention)(buttonContainer, _texts.friendWasAddedSuccesMessage);
      refreshButton();
    }).catch(error => {
      (0, _buttonsHelper.clearPreviousMessage)(buttonContainer);
      //else UI.widgets.complain(buttonContainer, message); //displays an error message at the top of the window
      (0, _buttonsHelper.complain)(buttonContainer, context, error);
    });
  }
  refreshButton();
  function refreshButton() {
    const me = _solidLogic.authn.currentUser();
    const store = context.session.store;
    if (checkIfAnyUserLoggedIn(me)) {
      button.disabled = false;
      checkIfThingExists(store, me, subject, _solidUi.ns.foaf('knows')).then(friendExists => {
        if (friendExists) {
          //logged in and friend exists or friend was just added
          button.textContent = _texts.friendExistsAlreadyButtonText;
        } else {
          //logged in and friend does not exist yet
          button.textContent = _texts.addMeToYourFriendsButtonText;
        }
      });
    } else {
      //not logged in — disable and indicate login is required
      button.textContent = _texts.logInAddMeToYourFriendsButtonText;
      button.disabled = true;
    }
  }
  return button;
};
exports.createAddMeToYourFriendsButton = createAddMeToYourFriendsButton;
async function saveNewThing(subject, context, predicate) {
  const me = _solidLogic.authn.currentUser();
  const store = context.session.store;
  if (checkIfAnyUserLoggedIn(me)) {
    if (!(await checkIfThingExists(store, me, subject, predicate))) {
      //if friend does not exist, we add her/him
      await store.fetcher.load(me);
      const updater = store.updater;
      const toBeInserted = [(0, _rdflib.st)(me, predicate, subject, me.doc())];
      try {
        await updater.update([], toBeInserted);
      } catch (error) {
        let errorMessage = error;
        if (errorMessage.toString().includes('Unauthenticated')) errorMessage = _texts.userNotLoggedInErrorMessage;
        throw new Error(errorMessage);
      }
    } else throw new Error(_texts.friendExistsMessage);
  } else throw new Error(_texts.userNotLoggedInErrorMessage);
}
function checkIfAnyUserLoggedIn(me) {
  if (me) return true;else return false;
}
async function checkIfThingExists(store, me, subject, predicate) {
  await store.fetcher.load(me);
  if (store.whether(me, predicate, subject, me.doc()) === 0) return false;else return true;
}